import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { LoadingState } from './ui/LoadingState';
import type { Application } from '../types';

export const CatalogRedirect: React.FC = () => {
  const { client } = useAuthStore();
  const navigate = useNavigate();

  const { data: apps, isLoading } = useQuery({
    queryKey: ['client_apps_smart_catalog', client?.id],
    queryFn: async () => {
      if (!client?.id) return [];
      const res = await api.get<{ data: Application[] }>(
        `/clients/${client.id}/applications?limit=1`
      );
      return res.data.data || [];
    },
    enabled: !!client?.id,
  });

  useEffect(() => {
    if (!isLoading) {
      if (apps && apps.length > 0) {
        navigate(`/applications/${apps[0].id}/catalog`, { replace: true });
      } else {
        navigate('/applications', { replace: true });
      }
    }
  }, [apps, isLoading, navigate]);

  return (
    <div className="container-custom py-12">
      <LoadingState type="card" count={1} />
    </div>
  );
};

export const SubscriptionsRedirect: React.FC = () => {
  const { client } = useAuthStore();
  const navigate = useNavigate();

  const { data: apps, isLoading } = useQuery({
    queryKey: ['client_apps_smart_subs', client?.id],
    queryFn: async () => {
      if (!client?.id) return [];
      const res = await api.get<{ data: Application[] }>(
        `/clients/${client.id}/applications?limit=1`
      );
      return res.data.data || [];
    },
    enabled: !!client?.id,
  });

  useEffect(() => {
    if (!isLoading) {
      if (apps && apps.length > 0) {
        navigate(`/applications/${apps[0].id}/subscriptions`, { replace: true });
      } else {
        navigate('/applications', { replace: true });
      }
    }
  }, [apps, isLoading, navigate]);

  return (
    <div className="container-custom py-12">
      <LoadingState type="card" count={1} />
    </div>
  );
};
